/* REACT PACKAGE IMPORTS */
import { useEffect, useState, useRef } from "react";

/* INTERNAL IMPORTS */
import SingleChoice from "./View/SingleChoice";
import MultipleChoice from "./View/MultipleChoice";

export default function QuestionComponent({
  position,
  questionType,
  questionHeader,
  question,
  answers,
  sessionId,
}) {
  const [questionComponent, setComponent] = useState(null);
  const userAnswer =
    answers.length > 0
      ? answers.filter((answer) => answer.qid === question.qid)
      : [];
  const mounted = useRef(null);

  useEffect(() => {
    mounted.current = true;
    if (questionComponent !== null) return;
    if (mounted.current) {
      switch (questionType) {
        case "singlechoice":
          setComponent(
            <SingleChoice
              position={position}
              question={question}
              answer={userAnswer}
              sessionId={sessionId}
            />
          );
          break;
        case "multichoice":
          setComponent(
            <MultipleChoice
              position={position}
              question={question}
              answer={userAnswer}
              sessionId={sessionId}
            />
          );
          break;
        default:
          setComponent(null);
          console.log("Unrecognized question type");
          break;
      }
    }

    return () => (mounted.current = false);
  }, [question]);

  return questionComponent;
}
